export function errorExistsIn<T extends { [s: number]: string }>(error: string | undefined, errors: T) {
  return (
    Object.values(errors).includes(error as string) && error
  ) as T[keyof T];
}
